<script lang="ts" setup>
import { useNavButton } from './composables/useNavButton'

const { locale } = useI18n()
const lang = computed(() => locale.value)
const route = useRoute()
const isCareerPage = computed(() => route.path.includes('/kariera'))
useNavButton()
</script>

<template>
  <Html :lang="lang">
    <Body
      :class="{
        whiteMenuLayout: true,
        'career-page': isCareerPage,
      }"
    >
      <UiNavigation :sticking="true" />

      <main class="main">
        <slot />
      </main>

      <UiFooter />
    </Body>
  </Html>
</template>

<style lang="scss">
.career-page {
  .navigation {
    box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.12);
  }
}

.whiteMenuLayout {
  .navigation-desktop {
    .navigation-desktop__list_item-dropdown {
      color: $white !important;

      &:hover {
        color: $purple-400 !important;
      }

      &:hover:after {
        background-image: url('/icons/arrow_down_purple.svg') !important;
      }

      &:after {
        background-image: url('/icons/arrow_down_white.svg') !important;
      }
    }

    .navigation-desktop__list_item-link {
      &--noDropdown {
        color: $white !important;

        &:hover {
          color: $purple-400 !important;
        }
      }
    }
    
    .navigation__logo {
      filter: invert(100%);
    }

    .button--primary {
      color: $text-400 !important;
      background-color: $white !important;
    }
  }

  .navigation {
    .navigation__logo {
      filter: invert(100%);
    }

    .hamburger span {
      background-color: $white !important;
    }

    &.is-open {
      .hamburger.is-open span {
        background-color: $text-400 !important;
      }

      .button--primary {
        color: $white !important;
        background-color: $text-400 !important;
      }
    }

    &.sticking {
      .hamburger span {
        background-color: $text-400 !important;
      }

      .navigation__logo {
        filter: inherit;
      }

      .button--primary {
        color: $white !important;
        background-color: $text-400 !important;
      }

        .navigation-desktop__list_item-dropdown {
        color: $text-400 !important;

        &:after {
          background-image: url('/icons/arrow_down.svg') !important;
        }
      }

      .navigation-desktop__list_item-link {
        &--noDropdown {
          color: $text-400 !important;
        }
      }
    }
  }
}
</style>
